import React from 'react'
import { useTranslation } from 'react-i18next';



const ProductCard = ({ index, name, gender, volume, price, image, id }) => {

  const { t, i18n } = useTranslation();


  const genderText = gender === 'men' 
    ? 'Kişi' 
    : gender === 'women' 
    ? 'Qadın' 
    : gender === 'unisex' 
    ? 'Unisex' 
    : '';


  return (
    <div className='bg-[white] rounded-[20px] w-[310px] min-h-[310px] px-6 py-4 mx-auto md:mx-0 border border-[#949494]' key={index}>
    <div className='m-3 text-[black]'>
      <div className='bg-[white] rounded-xl h-[167px] mb-3 flex justify-center items-center'>
        <img className='h-[160px] mx-auto' src={`https://www.tanura.az/tanura/${image}`} alt='' />
      </div>
      <h3 className='text-left text-[16px] font-medium'>{name}</h3>
      <a key={id} href={`/product-detail/${id}`}><button className='w-full mt-4 h-[40px] border border-[#223077] rounded-xl hover:bg-[#023077] hover:text-[white] transition-transform duration-300 ease-in-out'>{t("Ətraflı bax")}</button></a>
    </div>
  </div>
  )
}

export default ProductCard